import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError && this.state.error) {
      return (
        <div style={{ padding: '20px', fontFamily: 'sans-serif', maxWidth: '800px', margin: '20px auto' }}>
          <h2 style={{ color: '#c00' }}>Something went wrong</h2>
          <pre style={{ background: '#f5f5f5', padding: 12, overflow: 'auto' }}>
            {this.state.error.toString()}
          </pre>
          {this.state.error.stack && (
            <details>
              <summary>Stack trace</summary>
              <pre style={{ background: '#f5f5f5', padding: 12, fontSize: 12, overflow: 'auto' }}>
                {this.state.error.stack}
              </pre>
            </details>
          )}
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
